import { object, string } from 'yup';

export default object({
  callbackReason: string()
    .required()
    .label('Reden voor terugbelverzoek'),
});
